var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",class:[
    _vm.$style.button,
    _vm.$kindStyle[_vm.kindClass],
    _vm.$sizeStyle[_vm.sizeClass],
    ( _obj = {}, _obj[_vm.$style.fit] = _vm.fit, _obj ),
    ( _obj$1 = {}, _obj$1[_vm.$style.unread] = _vm.existsUnread, _obj$1 ) ]},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }